import React, { useState } from "react";
import StaticMenu from "src/components/molecules/StaticMenu";
import DynamicMenu from "src/components/molecules/DynamicMenu";
import { LogoutSVG } from "src/assets/svg";

const Left = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleMenu = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };
  return (
    <div className="h-full overflow-y-auto xl:overflow-y-hidden">
      <div className="text-light-blue font-bold text-3xl text-center mb-16 mt-8">SalesDash</div>
      <StaticMenu toggleMenu={toggleMenu} isOpen={isOpen} />
      <div>
        <DynamicMenu isOpen={isOpen} />
        <div className={isOpen ? "px-51.5px relative" : "px-51.5px relative -mt-40"}>
          <hr className="bg-light-gray h-[2px]" />
        </div>
      </div>
      <div className="relative mt-5">
        <div className="absolute px-51.5px flex items-center justify-center pb-5">
          <LogoutSVG class=" w-5 h-5 text-gray-600 p" />
          <span className="px-7 text-lg font-bold text-light-gray">Logout</span>
        </div>
      </div>
    </div>
  );
};

export default Left;
